import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

const MIN_PASTE_CONTENT_SIZE = 200;
const MAX_PASTE_CONTENT_SIZE = 1200;

export const shouldTriggerOnPaste = (text: string | undefined): boolean => {
	// Only check text character count
	if (!text) {
		return false;
	}

	const charCount = text.length;
	return (
		charCount >= MIN_PASTE_CONTENT_SIZE &&
		charCount <= MAX_PASTE_CONTENT_SIZE &&
		expValEquals('cc_improve_writing_on_paste', 'isEnabled', true)
	);
};

export const handlePasteStateChange = ({
	pasteState,
	editorView,
}: {
	pasteState: { lastContentPasted?: { text: string; timestamp: number } | null } | undefined;
	editorView: EditorView | undefined;
}) => {
	if (!pasteState?.lastContentPasted) {
		return;
	}

	const { lastContentPasted } = pasteState;

	// Check if the pasted content is large enough to trigger AI modal
	const shouldTrigger = shouldTriggerOnPaste(lastContentPasted.text);

	if (shouldTrigger && editorView) {
		// TODO: CFFD-525 - Add Improve Writing on Paste
	}
};
